import type { GenderEnum } from '@gql/graphql';
import type { Dayjs } from 'dayjs';
import type { HTMLAttributes, MouseEventHandler } from 'react';

export interface MtCardItemAnimalData {
  image?: string;
  name?: string;
  gender?: GenderEnum;
  birthday?: Dayjs;
  archived?: boolean;
  availableForBreeding?: boolean;
  onClick?: MouseEventHandler;
}

export interface MtCardItemAnimalProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick'>,
    MtCardItemAnimalData {}
